// 개인정보처리방침
const PrivacyPolicy = `주식회사 퍼니즈(이하 "회사")는 회사가 제공하는 Castar 서비스(웹/모바일 포함, 이하 "서비스")를 이용하는 이용자의 개인정보를 중요하게 생각하며, 「개인정보 보호법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 관련 법령을 준수합니다. 회사는 개인정보 처리와 관련한 이용자의 권리를 보호하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.

이 방침은 Castar 회원가입 및 서비스 이용 시 적용되며, 회원은 본 방침에 동의함으로써 회사의 개인정보 처리에 동의하게 됩니다.

제1조(처리 목적 및 기본 원칙)

1. 회사는 다음의 목적 범위에서만 개인정보를 수집·이용하며, 목적이 변경될 경우에는 관련 법령에 따라 별도의 동의를 받습니다.
  - 회원가입 및 본인확인
  - 배우–제작사 매칭 및 캐스팅 서비스 제공
  - 오디션 지원·진행 및 관련 커뮤니케이션
  - 서비스 운영·관리, 민원 처리 및 공지사항 전달
  - 유료 서비스 결제·환불, 정산 및 부정 이용 방지
  - 서비스 품질 개선, 통계·분석, 신규 서비스 개발
  - (선택 동의 시에 한하여) AI 기반 추천 기능 고도화 등
2. 회사는 최소 수집 원칙을 준수하며, 서비스 제공에 필요한 범위를 초과하여 개인정보를 수집·이용하지 않습니다.

제2조(수집 항목)

회사는 다음 각 호의 개인정보를 수집할 수 있습니다.

1. 회원가입 및 계정 관리(배우 회원 기준)
  - 필수: 이름, 생년월일, 성별, 이메일 주소(ID 포함), 비밀번호, 휴대전화번호, 닉네임
  - 선택: 거주 지역, 선호 장르, 기타 프로필 항목
2. 배우 포트폴리오 및 캐스팅을 위한 정보
  - 프로필 사진(안면, 반신, 전신 등), 이미지 및 영상 파일(자기소개, 연기 영상 등)
  - 신체 정보(키, 몸무게 등 캐스팅 목적상 필요한 범위)
  - 경력 및 활동 이력(필모그래피, 학력, 수상 경력, 소속 유무 등)
  - 자기소개, 특기, 언어 능력 등 본인이 입력한 추가 정보
3. 제작사/제작자 회원 정보(기업 회원 또는 캐스팅 담당자)
  - 담당자명, 직책, 이메일, 휴대전화번호
  - 회사명, 사업자등록번호, 사업장 주소, 홈페이지 URL 등
4. 서비스 이용 과정에서 자동으로 생성·수집되는 정보
  - 서비스 이용 기록, 접속 일시·IP 주소, 쿠키(cookie), 접속 기기 정보(단말기 OS, 브라우저 정보 등)
  - 로그인 기록, 오류 로그, 부정 이용 관련 기록
5. 결제 및 정산 관련 정보(유료 서비스 이용 시)
  - 카드사명, 카드번호 일부, 결제 승인번호, 결제 일시, 결제 금액 등 결제에 필요한 정보
  - 계좌이체 또는 정산이 필요한 경우: 은행명, 계좌번호, 예금주명 등
6. 문의·고객 상담 시 수집되는 정보
  - 문의 유형, 문의 내용, 이메일 주소, 연락처, 첨부 파일 등

제3조(수집 방법)

회사는 다음과 같은 방법으로 개인정보를 수집합니다.

1. 회원가입 및 서비스 이용 시 이용자가 직접 입력하는 경우
2. 포트폴리오/프로필 등록, 오디션 지원 등 서비스 기능 이용 과정에서 이용자가 자발적으로 제공하는 경우
3. 고객센터 문의, 이메일, 설문조사, 이벤트 응모 등 과정에서 이용자가 제공하는 경우
4. 서비스 이용 과정에서 자동으로 생성·수집되는 정보(로그, IP, 쿠키 등)

제4조(개인정보의 이용 목적)

회사는 수집한 개인정보를 다음 각 호의 목적 범위에서 이용합니다.

1. 회원 식별, 가입 의사 확인, 본인·연령 확인, 계정 관리
2. 배우 포트폴리오 생성·관리 및 제작사에게의 열람 제공
3. 오디션 공고 열람, 지원, 합격 통지 등 캐스팅 과정 전반의 진행
4. 서비스 이용 내역 확인, 문의·불만 처리, 공지사항 전달
5. 서비스 악용·부정 이용 방지(무단 계정 공유, 명의 도용, 반복적인 부정 환불 등)
6. 유료 서비스 결제·환불, 정산 및 관련 회계처리
7. 서비스 품질 개선, 통계 작성, 접속·이용 패턴 분석 등 운영 효율화
8. 신규 기능·서비스 개발 및 이용자 경험 개선
9. (선택 동의 시에 한하여) 배우 추천 알고리즘 및 AI 모델 고도화 목적

제5조(보유 및 이용 기간)

1. 회사는 원칙적으로 개인정보의 수집·이용 목적이 달성된 후에는 지체 없이 해당 정보를 파기합니다.
2. 다만, 다음 각 호의 정보에 대해서는 아래 기간 동안 보관할 수 있습니다.
  - 계약 또는 청약철회 등에 관한 기록: 5년
  - 대금 결제 및 재화·서비스 공급에 관한 기록: 5년
  - 소비자의 불만 또는 분쟁 처리에 관한 기록: 3년
  - 표시·광고에 관한 기록: 6개월
  - 접속 기록(IP 포함): 3개월
3. 서비스 부정 이용 방지를 위하여, 회사는 회원 탈퇴 후 최대 1년간 최소한의 정보(아이디, 본인인증값, 부정 이용 관련 기록 등)를 보관할 수 있습니다.
4. 법령에서 별도의 보관기간을 정하고 있는 경우, 해당 기간 동안 개인정보를 보관할 수 있습니다.

제6조(개인정보의 제3자 제공)

1. 회사는 원칙적으로 이용자의 동의 없이 개인정보를 제3자에게 제공하지 않습니다.
2. 다만, 다음 각 호의 경우에는 예외적으로 제공될 수 있습니다.
  - 이용자가 사전에 제3자 제공에 명시적으로 동의한 경우
  - 법령에 의하여 수사기관 또는 감독기관이 적법한 절차에 따라 요청한 경우
  - 통계 작성, 학술 연구 등의 목적을 위하여 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우
3. 배우–제작사 매칭을 위해 제작사에게 제공되는 개인정보는 "[필수] 개인정보 제3자 제공 동의(제작사 제공)" 항목에서 별도로 구체적으로 고지하고 동의를 받습니다.

제7조(개인정보 처리의 위탁)

1. 회사는 서비스 제공의 효율성을 위하여 일부 개인정보 처리를 외부 전문업체에 위탁할 수 있습니다.
2. 이 경우 회사는 위탁업체, 위탁 업무의 내용, 보유·이용 기간 등을 개인정보 처리방침에 공개하며, 필요한 경우 별도의 동의를 받을 수 있습니다.
3. 회사는 위탁계약 체결 시 개인정보 보호 관련 법령을 준수하고, 수탁자가 개인정보를 안전하게 처리하도록 관리·감독합니다.

AWS, inc. - 클라우드 서버 운영
(주)알리는 사람들 - 본인인증

제8조(개인정보의 파기)

1. 회사는 개인정보 보유기간의 경과, 처리 목적 달성 등 그 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 정보를 파기합니다.
2. 전자적 파일 형태의 정보는 복구·재생이 불가능한 방법으로 영구 삭제하며, 종이 문서는 분쇄 또는 소각 등의 방법으로 파기합니다.
3. 다른 법령에 따라 일정 기간 보관이 필요한 경우, 해당 개인정보는 별도의 DB 또는 저장공간에 분리 보관하며, 법령상 목적 외로 이용하지 않습니다.

제9조(이용자의 권리와 행사 방법)

1. 이용자는 언제든지 자신의 개인정보에 대하여 열람, 정정, 삭제, 처리정지, 동의 철회를 요청할 수 있습니다.
2. 서비스 내 "마이페이지" 또는 고객센터를 통해 직접 신청하거나, 이메일 등으로 요청할 수 있습니다.
3. 회사는 이용자의 요청을 받은 경우 지체 없이 필요한 조치를 취하고, 그 결과를 통지합니다.
4. 이용자가 개인정보의 정정을 요청한 경우, 회사는 정정이 완료될 때까지 해당 개인정보를 이용하거나 제3자에게 제공하지 않습니다.
5. 법령에서 정하는 바에 따라, 회사는 이용자의 권리 행사 요청에 대하여 제한이 있을 수 있으며, 이 경우 그 사유를 안내합니다.

제10조(이용자의 의무)

1. 이용자는 자신의 개인정보를 최신의 상태로 정확하게 입력·관리하여야 하며, 부정확한 정보 제공으로 발생하는 문제에 대한 책임은 이용자에게 있습니다.
2. 이용자는 타인의 개인정보를 도용하여 회원가입 또는 서비스 이용을 해서는 안 되며, 이를 위반할 경우 관련 법령에 따라 제재를 받을 수 있습니다.
3. 계정(아이디, 비밀번호 등)의 관리 책임은 이용자에게 있으며, 이를 제3자에게 양도·대여·공유해서는 안 됩니다.

제11조(쿠키(Cookie)의 사용)

1. 회사는 이용자의 편의와 맞춤형 서비스 제공을 위해 쿠키를 사용할 수 있습니다.
2. 이용자는 브라우저 설정을 통해 쿠키 저장을 거부하거나, 저장 시마다 확인하는 등 선택할 수 있습니다. 다만, 쿠키 거부 시 로그인 기반 일부 서비스 이용에 제한이 있을 수 있습니다.

제12조(장기 미이용자의 개인정보 분리 보관)

1. 회사는 일정 기간 동안 서비스 이용 기록이 없는 회원(예: 1년)을 "장기 미이용자"로 분류하여, 해당 계정의 개인정보를 별도로 분리 보관하거나 파기할 수 있습니다.
2. 이 경우 회사는 분리 보관 또는 파기 예정일 30일 이전까지 이메일 등으로 사전 통지합니다.
3. 장기 미이용자는 다시 로그인하여 서비스 이용 의사를 밝힐 경우, 동의 절차에 따라 계정을 복원할 수 있습니다.

제13조(개인정보의 안전성 확보 조치)

회사는 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 다음과 같은 보호조치를 취하고 있습니다.

1. 비밀번호 및 중요 정보의 암호화
2. 접근 권한 관리, 내부 직원 최소 접근 원칙 적용
3. 백신 소프트웨어, 침입 차단 시스템 등 보안 시스템 운영
4. 개인정보 처리 직원에 대한 정기적 교육 및 관리 감독
5. 기타 법령에서 요구하는 기술적·관리적 보호조치

제14조(개인정보 보호책임자)

회사는 이용자의 개인정보를 보호하고 관련 민원 처리를 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.

- 개인정보 보호책임자: 임선후
- 직위/부서: 팀장 / B&O 팀
- 연락처: 010-4068-3464
- 이메일: limsunhu@naver.com

이용자는 서비스 이용 중 발생하는 모든 개인정보보호 관련 문의, 불만, 피해구제 등에 관하여 위 연락처로 문의할 수 있으며, 회사는 지체 없이 답변 및 처리합니다.

제15조(개인정보 처리방침의 변경)

1. 회사는 법령·정책 또는 서비스 내용의 변경에 따라 개인정보 처리방침을 개정할 수 있습니다.
2. 방침을 변경하는 경우, 개정 내용과 시행일을 명시하여 서비스 내 공지사항 또는 팝업 등을 통해 최소 7일 전부터 공지하며, 이용자에게 불리한 변경의 경우에는 최소 30일 전에 공지합니다.
3. 중대한 변경이 있을 경우, 회사는 필요한 경우 별도의 동의를 다시 받을 수 있습니다.

"본인은 주식회사 퍼니즈의 Castar 서비스 개인정보처리방침(전문)을 확인하였으며, 이에 동의합니다."`;

export default PrivacyPolicy;
